import type { TFunction } from 'i18next';
import { ExplorerTopLevelEntity } from '../../../server/utils/explorer-utils.ts';

export function getExplorerTabLabel(t: TFunction<'explorer'>, tab: ExplorerTopLevelEntity): string {
    switch (tab) {
        case ExplorerTopLevelEntity.CLERK:
            return t('header_tab__CLERK', { ns: 'explorer' });
        case ExplorerTopLevelEntity.CUSTOMER:
            return t('header_tab__CUSTOMER', { ns: 'explorer' });
        case ExplorerTopLevelEntity.INDUSTRY:
            return t('header_tab__INDUSTRY', { ns: 'explorer' });
        case ExplorerTopLevelEntity.NORMALISED_CATEGORY:
            return t('header_tab__NORMALISED_CATEGORY', { ns: 'explorer' });
        case ExplorerTopLevelEntity.PRODUCT:
            return t('header_tab__PRODUCT', { ns: 'explorer' });
        case ExplorerTopLevelEntity.PRODUCT_GROUP:
            return t('header_tab__PRODUCT_GROUP', { ns: 'explorer' });
        case ExplorerTopLevelEntity.SALES_REP:
            return t('header_tab__SALES_REP', { ns: 'explorer' });
        case ExplorerTopLevelEntity.STORAGE_LOCATION:
            return t('header_tab__STORAGE_LOCATION', { ns: 'explorer' });
        case ExplorerTopLevelEntity.SUPPLIER:
            return t('header_tab__SUPPLIER', { ns: 'explorer' });
    }
}

export function getExplorerSearchPlaceholder(t: TFunction<'explorer'>, tab: ExplorerTopLevelEntity): string {
    switch (tab) {
        case ExplorerTopLevelEntity.CLERK:
            return t('search_placeholder__CLERK', { ns: 'explorer' });
        case ExplorerTopLevelEntity.CUSTOMER:
            return t('search_placeholder__CUSTOMER', { ns: 'explorer' });
        case ExplorerTopLevelEntity.INDUSTRY:
            return t('search_placeholder__INDUSTRY', { ns: 'explorer' });
        case ExplorerTopLevelEntity.NORMALISED_CATEGORY:
            return t('search_placeholder__NORMALISED_CATEGORY', { ns: 'explorer' });
        case ExplorerTopLevelEntity.PRODUCT:
            return t('search_placeholder__PRODUCT', { ns: 'explorer' });
        case ExplorerTopLevelEntity.PRODUCT_GROUP:
            return t('search_placeholder__PRODUCT_GROUP', { ns: 'explorer' });
        case ExplorerTopLevelEntity.SALES_REP:
            return t('search_placeholder__SALES_REP', { ns: 'explorer' });
        case ExplorerTopLevelEntity.STORAGE_LOCATION:
            return t('search_placeholder__STORAGE_LOCATION', { ns: 'explorer' });
        case ExplorerTopLevelEntity.SUPPLIER:
            return t('search_placeholder__SUPPLIER', { ns: 'explorer' });
    }
}
